export default "__VITE_ASSET__115665ad__"